module.exports = __webpack_public_path__ + "img/export-xlsx-file.722e15e1.png";